import {Component, OnInit } from '@angular/core';
import { SecureStorageService } from 'src/app/core/validators/secure-storage.service';

@Component({
  standalone: false,
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.css']
})
export class ContentLayoutComponent implements OnInit  {

  fillColor: string = '#0f395c';
  animar = true;
  numeroWhatsapp: string = "";
  mensajeWhatsapp: string = "";
  wabeExist = "";
  flagPCI: string = "NO";
  constructor(
    private secureStorageService: SecureStorageService
  ){}

  ngOnInit() {

    const data = JSON.parse(this.secureStorageService.getData('designConfig') || "false");
    if(data){
      this.wabeExist = data.WAVE;
      this.numeroWhatsapp = data.NUMERO_TELEFONO_WHATSAPP;
      this.mensajeWhatsapp = data.MENSAJE_PREDETERMINADO_WHATSAPP;
      this.flagPCI = data.MOSTRAR_LOGO_PCI;
      if(this.wabeExist){
        const wabeElement = document.querySelectorAll('.svg-wabe');
        if(wabeElement){
          wabeElement.forEach(wabeElement => {
            wabeElement.setAttribute('src', data.WAVE);
          });
        }
      }

    }

    
    this.fillColor = getComputedStyle(document.documentElement).getPropertyValue('--color-primario').trim();
  }


  mostrarPCI(){
    if(this.flagPCI === "SI"){
      return true;
    }
    return false
  }

  sendMessage() {
    const phoneNumber = this.numeroWhatsapp;
    const message = encodeURIComponent(this.mensajeWhatsapp);
    let baseUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${message}`;

    window.open(baseUrl, '_blank');
  }
}
